import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import { getSegmentsService } from '../services/segments.service';
import { TSegmentsReqParams, TSegmentsResponse } from '../types/segments.types';

export const segmentsQueryKeys = createQueryKeys(EQueryKeys.SegmentsQueryKeys, {
  getSegmentsData: (counterpartyGUID: string, params?: TSegmentsReqParams) => ({
    queryKey: ['segments-list-data', counterpartyGUID, params],
    queryFn: (): Promise<TSegmentsResponse> => getSegmentsService(counterpartyGUID, params),
  }),
});
